import { PageUtils } from "./helpers/page-utils";

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    const siteHeader = document.getElementById('siteHeader');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.remove('opacity-0','pointer-events-none');
    }
    if (siteHeader) {
        const headerHeight = siteHeader.getBoundingClientRect().height;
        const scrollDistance = window.scrollY || document.documentElement.scrollTop;

        if (scrollDistance <= headerHeight) {
            siteHeader.dataset.visible = 'true';
        }
    }
    setTimeout(() => {
        lightbox.remove();
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();

    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.add('opacity-0','pointer-events-none');
    }
    siteHeader.dataset.visible = 'false';
    docBody.dataset.navVisible = 'false';

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}

window.addEventListener("load", () => {
    const validCardPanels = document.querySelectorAll(".card-panel-categories, .house-card-grid-panel, .card-panel-estate, .card-panel-map, .card-panel-related-homes");

    if (!validCardPanels) return;

    for (const cardPanel of validCardPanels) {
        const hasVariantCards = cardPanel.querySelector("[data-hd-card]");

        if (!hasVariantCards) return;

        cardPanel.addEventListener("click", (event) => {
            const button = event.target.closest('button[data-hd-variant], button[data-hd-floorplan-button], div[data-showing-floorplan="true"]');

            if (!button) return;

            const card = button.closest("[data-hd-card]");

            if (!card) return;

            // Handle floorplan toggle button separately
            if (button.matches("button[data-hd-floorplan-button]")) {
                const floorplanContainer = button.closest("div[data-showing-floorplan]");
                if (!floorplanContainer) return;

                const isShowing = floorplanContainer.dataset.showingFloorplan === "true";
                floorplanContainer.dataset.showingFloorplan = isShowing ? "false" : "true";
                return;
            }

            // create a lightbox for a zoomed in floorplan when floorplan is clicked
            if (button.matches('div[data-showing-floorplan="true"]')) {
                const img = button.querySelector('img[data-hd-floorplan]');

                if (img) {
                    // Get the image source from the button
                    const imageSrc = img.getAttribute('src');

                    // Create the lightbox element
                    const lightbox = document.createElement('div');
                    lightbox.dataset.lightboxFloorplan = '';
                    lightbox.dataset.hidden = 'true';
                    lightbox.dataset.visible = 'false';
                    lightbox.className =
                        "w-screen h-screen flex items-center ios-vh-fix z-[99999] fixed top-0 left-0 transition-opacity duration-300 backdrop-blur-md data-[visible=false]:pointer-events-none data-[visible=false]:opacity-0 data-[hidden=true]:hidden";

                    lightbox.innerHTML = `
                        <div class="max-w-8xl mx-auto relative w-full h-full z-1 p-8">
                            <div class="w-full h-full relative">
                                <img src="${imageSrc}" class="pointer-events-none absolute inset-0 w-full h-full object-center object-contain" alt />
                            </div>
                        </div>
                        <div class="absolute pointer-events-none w-full h-full max-w-8xl mx-auto top-0 left-1/2 -translate-x-1/2 z-3">
                            <button type="button" title="Click to close lightbox" data-lightbox-close
                                class="!ring-0 !ring-transparent absolute right-4 top-4 w-10 h-10 bg-green-brand rounded-lg cursor-pointer pointer-events-auto xs:top-4 xs:right-4 lg:top-8 lg:right-8 xs:bg-opacity-20 group">
                                <svg class="fill-white w-10 h-10 p-2 pointer-events-none group-hover:scale-110 transition-all duration-300 group-hover:rotate-90" width="40" height="40" viewBox="0 0 40 40" fill="#000" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.29 20.0001L30.65 10.6401C31.01 10.2901 31.01 9.71008 30.65 9.35008C30.29 8.99008 29.72 8.99008 29.36 9.35008L20 18.7101L10.64 9.35008C10.29 8.99008 9.70996 8.99008 9.34996 9.35008C8.98996 9.70008 8.98996 10.2801 9.34996 10.6401L18.71 20.0001L9.34996 29.3601C8.98996 29.7101 8.98996 30.2901 9.34996 30.6501C9.52996 30.8301 9.75996 30.9201 9.98996 30.9201C10.22 30.9201 10.46 30.8301 10.63 30.6501L19.99 21.2901L29.35 30.6501C29.53 30.8301 29.76 30.9201 29.99 30.9201C30.22 30.9201 30.45 30.8301 30.63 30.6501C30.99 30.3001 30.99 29.7201 30.63 29.3601L21.27 20.0001H21.29Z" fill="inherit"/>
                                </svg>
                            </button>
                        </div>
                        <div data-lightbox-backdrop class="absolute top-0 left-0 w-full h-full bg-green-brand/75 z-0"></div>
                    `;

                    // Append the lightbox to the document body
                    document.body.appendChild(lightbox);

                    // Run the openLightBox function
                    openLightBox(lightbox);

                    // Add event listeners for close interactions
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

                    const closeHandler = () => {
                        closeLightBox(lightbox);
                        cleanup();
                    };

                    const keydownHandler = (event) => {
                        if (event.key === 'Escape') {
                            closeLightBox(lightbox);
                            cleanup();
                        }
                    };

                    const cleanup = () => {
                        // Remove event listeners
                        if (lightboxBackdrop) lightboxBackdrop.removeEventListener('click', closeHandler);
                        if (lightboxClose) lightboxClose.removeEventListener('click', closeHandler);
                        document.removeEventListener('keydown', keydownHandler);
                    };

                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', closeHandler);
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', closeHandler);
                    }
                    document.addEventListener('keydown', keydownHandler);
                }
            }


            // Map button data attributes to the target elements
            const mappings = {
                "data-hd-variant-storeys": "[data-hd-storeys]",
                "data-hd-variant-beds": "[data-hd-beds]",
                "data-hd-variant-baths": "[data-hd-baths]",
                "data-hd-variant-cars": "[data-hd-cars]",
                "data-hd-variant-price": "[data-hd-price]",
                "data-hd-variant-house-width": "[data-hd-house-width]",
                "data-hd-variant-min-block-width": "[data-hd-min-block-width]",
                "data-hd-variant-image-high": "img[data-hd-image]",
                "data-hd-variant-url": "a[data-hd-url]",
                "data-hd-variant-floorplan": "img[data-hd-floorplan]",
                "data-hd-variant-range": "[data-hd-range]",
                "data-hd-variant-range-logo": "img[data-hd-range-logo]",
                "data-hd-variant-home-design-flag": "[data-hd-home-design-flag]",
                "data-hd-variant-home-design-flag-title": "[data-hd-home-design-flag-title]",
                "data-hd-variant-home-design-flag-bg": "[data-hd-home-design-flag-bg]",
                "data-hd-variant-home-design-flag-col": "[data-hd-home-design-flag-col]"
            };

            // Update elements based on mappings
            Object.entries(mappings).forEach(([buttonAttr, targetSelector]) => {
                const targetElement = card.querySelector(targetSelector);
                const value = button.getAttribute(buttonAttr);

                if (!targetElement || value === null) return;

                if (targetSelector === "img[data-hd-image]" || targetSelector === "img[data-hd-range-logo]") {
                    targetElement.setAttribute("src", value);
                } else if (targetSelector === "a[data-hd-url]") {
                    targetElement.setAttribute("href", value);
                } else if (targetSelector === "img[data-hd-floorplan]") {
                    const floorplanContainer = targetElement.closest("div[data-showing-floorplan]");
                    const floorplanButton = floorplanContainer?.querySelector("button[data-hd-floorplan-button]");

                    if (floorplanContainer.dataset.defaultFloorplan === 'false') {
                        floorplanContainer?.setAttribute("data-showing-floorplan", "false");
                    } else {
                        floorplanContainer?.setAttribute("data-showing-floorplan", "true");
                    }
                    floorplanButton?.setAttribute("disabled", "");

                    if (buttonAttr === "data-hd-variant-floorplan" && value) {
                        targetElement.setAttribute("src", value);
                        floorplanButton?.removeAttribute("disabled");
                    }
                }
                else if (targetSelector === '[data-hd-home-design-flag]') {
                    targetElement.dataset.hdHomeDesignFlag = value;
                }
                else if (targetSelector === '[data-hd-home-design-flag-title]') {
                    targetElement.innerText = value;
                }
                else if (targetSelector === '[data-hd-home-design-flag-bg]') {
                    targetElement.style.background = value;
                }
                else if (targetSelector === '[data-hd-home-design-flag-col]') {
                    targetElement.style.color = value;
                }
                else {
                    targetElement.textContent = value;
                }
            });

            // Update button states
            card.querySelectorAll("button[data-hd-variant]").forEach((btn) => {
                btn.setAttribute("data-active", btn === button ? "true" : "false");
            });
        });
    }
});
